import type { Config } from '../createConfig';
import { deepEqual } from '../utils/deepEqual';
import { getConnections, type GetConnectionsReturnType } from './getConnections';

export type WatchConnectionsParameters = {
  onChange(connections: GetConnectionsReturnType, prevConnections: GetConnectionsReturnType): void;
};

export type WatchConnectionsReturnType = () => void;

export function watchConnections(config: Config, parameters: WatchConnectionsParameters): WatchConnectionsReturnType {
  const { onChange } = parameters;
  return config.subscribe(() => getConnections(config), onChange, {
    equalityFn: deepEqual,
  });
}
